import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import english from './locales/english.json'
import arabic from './locales/arabic.json'
import Cookies from 'js-cookie'

const resources = {
    en: {
        translation: english
    },
    ar: {
        translation: arabic
    }
};

i18n.use(LanguageDetector).use(initReactI18next).init({
    resources,
    lng: Cookies.get('fj_lang') || 'en',
    fallbackLng: "en",
    debug: true,
    detection: {
        order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
        lookupCookie: 'i18next',
    }
})

export default i18n